



























































import { editFactory } from '@/main/pages';
import { TabulkovaPozice } from '@/modules/ciselnik/dilenske/tabulkovaPozice';

import { store } from './store/edit';
import { NAME } from './constants';
import { editMutations } from './store/types';

export default editFactory(NAME, store).extend({
	components: {
		TabulkovaPoziceSelect: TabulkovaPozice.components.Select,
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				tablPozice: `${this.storeUri}/${editMutations.PRACOVNI_POZICE_TABULKOVA_POZICE_SELECT_MAPPER}`,
			};
		},
	},
});
